import ContactsList from './ContactsList.page';

export default ContactsList;
